import React, { useState } from 'react';
import { Box, Typography, Collapse, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface FormSectionProps {
	title: string;
	children: React.ReactNode;
	collapsible?: boolean;
	defaultExpanded?: boolean;
	fieldCount?: number;
}

const FormSection: React.FC<FormSectionProps> = ({
	title,
	children,
	collapsible = false,
	defaultExpanded = true,
	fieldCount,
}) => {
	const [expanded, setExpanded] = useState(defaultExpanded);

	return (
		<Box
			sx={{
				border: 1,
				borderColor: 'divider',
				borderRadius: 1,
				overflow: 'hidden',
			}}
		>
			<Box
				onClick={collapsible ? () => setExpanded((prev) => !prev) : undefined}
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					px: 2,
					py: 1,
					bgcolor: 'action.hover',
					cursor: collapsible ? 'pointer' : 'default',
					userSelect: 'none',
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Typography variant="subtitle2" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
						{title}
					</Typography>
					{collapsible && !expanded && fieldCount !== undefined && fieldCount > 0 && (
						<Typography
							variant="caption"
							sx={{ color: 'text.secondary' }}
						>
							({fieldCount} {fieldCount === 1 ? 'field' : 'fields'} set)
						</Typography>
					)}
				</Box>
				{collapsible && (
					<IconButton size="small" sx={{ p: 0.25 }}>
						<ExpandMoreIcon
							sx={{
								transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
								transition: 'transform 200ms',
								fontSize: '1.2rem',
							}}
						/>
					</IconButton>
				)}
			</Box>
			<Collapse in={!collapsible || expanded}>
				<Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
					{children}
				</Box>
			</Collapse>
		</Box>
	);
};

export default FormSection;
